module.exports = __webpack_public_path__ + "media/images/emblems/Roche_(Vaud)-coat_of_arms-74c3b711f22a917d13c13c8e4b5b3b89.svg";